import { Filter, ConditionOperatorsEnum } from 'utils/filters';

export const filterOptions: Filter[] = [
  {
    field: 'client_name',
    label: 'DYNAMIC_FILTER.CLIENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'environment_name',
    label: 'DYNAMIC_FILTER.ENVIRONMENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'partner_name',
    label: 'DYNAMIC_FILTER.PARTNER_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'company_name',
    label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  { field: 'identification', label: 'DYNAMIC_FILTER.IDENTIFICATION_KEY' },
  {
    field: 'external_client_code',
    label: 'DYNAMIC_FILTER.EXTERNAL_CLIENT_CODE_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'client_new_front_enabled',
    label: 'DYNAMIC_FILTER.CLIENT_USE_NEW_FRONT_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'virtualizer',
    label: 'DYNAMIC_FILTER.VIRTUALIZER_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'connect', label: 'DYNAMIC_FILTER.CONNECT_KEY' },
      { value: 'connect_direct', label: 'DYNAMIC_FILTER.CONNECT_DIRECT_KEY' },
      { value: 'rdp', label: 'DYNAMIC_FILTER.RDP_KEY' },
      { value: 'rdp_direct', label: 'DYNAMIC_FILTER.RDP_DIRECT_KEY' },
      { value: 'rdp_app', label: 'DYNAMIC_FILTER.RDP_APP_KEY' },
      { value: 'tsplus', label: 'DYNAMIC_FILTER.TSPLUS_KEY' },
      {
        value: 'tsplus_remote_app',
        label: 'DYNAMIC_FILTER.TSPLUS_REMOTE_APP_KEY',
      },
      { value: 'tsplus_all', label: 'DYNAMIC_FILTER.TSPLUS_ALL_KEY' },
    ],
  },
  {
    field: 'connection_type',
    label: 'DYNAMIC_FILTER.CONNECTION_TYPE_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'public', label: 'DYNAMIC_FILTER.PUBLIC_KEY' },
      { value: 'private', label: 'DYNAMIC_FILTER.PRIVATE_KEY' },
    ],
  },
  {
    field: 'user_mfa_is_active',
    label: 'MFA',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'use_profile',
    label: 'LOGS_PAGE.FIELDS.USE_PROFILE_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'block_multiple_session',
    label: 'DYNAMIC_FILTER.BLOCK_MULTIPLE_SESSION_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  { field: 'client_uuid', label: 'DYNAMIC_FILTER.CLIENT_UUID_KEY' },
  { field: 'environment_uuid', label: 'DYNAMIC_FILTER.ENVIRONMENT_UUID_KEY' },
  { field: 'partner_uuid', label: 'DYNAMIC_FILTER.PARTNER_UUID_KEY' },
  { field: 'company_uuid', label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY' },
];
